import { commonFlow } from './common';

export default function getRestaurant(data) {
  let options = [{
    value: `o_order`,
    label: "I want to place an order",
    trigger: `r_order`
  }];

  let responses = [{
      id: `r_order`,
      message: "Ok. For pickup or delivery?",
      trigger: `options_order_delivery`
    },
    {
      id: `options_order_delivery`,
      options: [
        { value: 1, label: 'Pickup', trigger: `f_order_1` },
        { value: 2, label: 'Delivery', trigger: 'r_delivery_1' }
      ],
    },
    {
      id: `r_delivery_1`,
      message: data.botResponse[3],
      trigger: `options_delivery_2`
    },
    {
      id: `options_delivery_2`,
      options: [
        { value: 1, label: 'Yes', trigger: `f_order_1` },
        { value: 2, label: 'No', trigger: 'penultimate' }
      ],
    }
  ];

  let userInputs = [
    {
      id: `u_order_1`,
      user: true,
      trigger: `f_order_2`
    },
    {
      id: 'u_order_2',
      user: true,
      trigger: 'f_order_3'
    }
  ];

  let followUps = [
    {
      id: `f_order_1`,
      message: data.botResponse[0],
      trigger: `u_order_1`
    },
    {
      id: `f_order_2`,
      message: "Please tell me your name and phone number. We will contact you once the order is ready",
      trigger: `u_order_2`
    },
    {
      id: 'f_order_3',
      message: data.botResponse[1],
      trigger: `options_order_3`
    },
    {
      id: `options_order_3`,
      options: [
        { value: 1, label: 'Confirm', trigger: `f_order_4` },
        { value: 2, label: 'No, I want to change my order', trigger: 'u_order_1' },
        { value: 3, label: 'Cancel my order and end the chat now', trigger: 'penultimate'}
      ],
    },
    {
      id: `f_order_4`,
      message: data.botResponse[2],
      trigger: 'penultimate'
    }
  ];

  // Arrays will mutate
  commonFlow(data, options, responses, userInputs, followUps);

  return [
    {
      id: 'start',
      message: data.greetings && data.greetings !== "" ? data.greetings : "Hello! How can I help?",
      trigger: 'options',
    },
    {
      id: 'options',
      options: options
    },
    ...responses,
    ...userInputs,
    ...followUps,
    {
      id: 'penultimate',
      message: "Can I help you with anything else?",
      trigger: 'options_2'
    },
    {
      id: 'options_2',
      options: [
        { value: 1, label: 'Yes, I would like to see the options.', trigger: 'options' },
        { value: 2, label: 'No, I would like to end the chat.', trigger: 'departing_thanks' },
        { value: 3, label: 'Start over.', trigger: () => window.location.reload() }
      ],
    },
    {
      id: 'departing_thanks',
      message: data.botResponse[4],
      trigger: 'bye'
    },
    {
      id: 'bye',
      message: 'Bye!',
      end: true
    }
  ];
}
